/**
 * @module wdh-accordion-spot
 */

import WDHAccordionSpot from './src/js/wdh-accordion-spot';
import AccordionSpot from './src/js/react-accordion-spot';
import AccordionSpotTabs from './src/js/variation/react-accordion-spot-tabs';
export { WDHAccordionSpot, AccordionSpot, AccordionSpotTabs };